
import headerBackTitle from '@/components/header/headerBackTitle'
import listItem from '@/components/donateTogether/listItem'
import Datetime from 'vux/src/components/datetime/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'

export default {
neme: 'dTEdit',
data() {
return {
itemTitle: '',
itemDescription: '',
acr001: this.$route.params.acr001,
epId: this.$route.params.epId,//'527492462491467776',
companyInfo: '', //企业名称
isFirstEnter: false,
deadlineDate:'',
goalMoney:'',
format:'YYYY-MM-DD',
details:{},
isUpdate:false
}
},
components: {
headerBackTitle,
listItem,
Datetime ,
XInput,
XTextarea,
Group
},
computed:{
today(){
let date = new Date()
let year = date.getFullYear()
let month = date.getMonth()
let day = date.getDate()
let startDate
if(month<10) {
startDate = year +'-0'+(month+1)+'-'+day
}else{
startDate = year +'-'+(month+1)+'-'+day
}
return startDate

},
alreadyMoney() {
let money = this.details.alreadyMoney
if(money >= 1000000){
let divide = money/10000
return divide.toFixed(3).slice(0,-1)
}else{
return money
}
}
},
methods: {
getDetail () {
let data={
acr001: this.acr001
}
this.$https.post(this.BASE_URL+"cfs/zc/project/getLoadxmxx",
data,
)
.then(res => {
this.details = res.data.data;

})
.catch(function(err) {
console.log(err);
})
},



inputBlur() {

document.body.scrollTop = 100
},

nextPublish() {
if(this.itemTitle !=='' && this.itemDescription !=='') {
if(this.itemTitle.length < 3){
this.showToast('','text','团队名称不能少于3个字','20em','','')
return
}
if(this.deadlineDate == ''){
this.showToast('','text','请输入结束时间','20em','','')
return
}else{
let iDays
if(this.details.aar021) {
let deadline = this.details.aar021.replace(/[.]/g,'-')

let dateSpan
let tempDate
let selectData = Date.parse(this.deadlineDate);
deadline = Date.parse(deadline);
dateSpan = deadline - selectData;

iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
console.log(iDays)
if(iDays < 0) {
this.showToast('','text','不能超过项目的结束时间哦~','20em','','')
return
}
}
}
let reg =/^[1-9]\d*$/

if(this.goalMoney == ''){
this.showToast('','text','请输入目标金额','20em','','')
return
}else if(parseFloat(this.goalMoney) > parseFloat(this.details.planMoney)) {
this.showToast('','text','不能大于总目标金额哦~','20em','','')
return
}else if(!reg.test(this.goalMoney)){
this.showToast('','text','请输入有效的总目标金额哦~','20em','','')
return
}else if(parseFloat(this.goalMoney) < 1) {
this.showToast('','text','目标金额不能太少哦~','20em','','')
return
}
if(this.itemDescription.length < 5){
this.showToast('','text','团队介绍不能少于5个字','20em','','')
return
}
this.L('itemTitle',this.itemTitle)
this.L('itemDescription',this.itemDescription)
this.L('companyLogo',this.companyInfo.orgLogo)
this.L('companyName',this.companyInfo.orgName)
this.L('goalMoney',this.goalMoney)
this.L('deadlineDate',this.deadlineDate)
this.$router.push("/dTPublish/"+this.acr001+'/'+this.epId)
}else {
this.showToast('','text','输入信息不能为空','20em','','')
}
},

getCompanyInfo() {
let data = {
epId: this.epId
}
this.$https.post(this.BASE_URL+"grd/groupDonation/getEnterpriseLogoAndNameById",
data,
)
.then(res => {
this.companyInfo = res.data.data
})
.catch(function(err) {
console.log(err);
})
}
},
activated() {
if(!this.$route.meta.isUseCache){
this.acr001 = this.$route.params.acr001
this.itemTitle = ''
this.itemDescription = ''
this.goalMoney = ''
this.deadlineDate = ''
this.getCompanyInfo()
this.getDetail()
}
},
created() {
this.isFirstEnter = true
this.getCompanyInfo()
this.getDetail()
},
beforeRouteEnter (to, from, next) {
if (from.name == 'zcprojectDetail') {
to.meta.isUseCache = false;
}
next();
}
}



// WEBPACK FOOTER //
// ./src/crowd_fund/dTEdit.vue